export interface IDocumentoGenericoDTO {
  estado?: string;
  firmas?: IFirmas[];
  solicitudId?: string;
  solucionId?: string;
  tipoDocumento?: string;
  url?: string;
  contenidoBase64?: string;
  createdDate?: Date;
  lastModifiedDate?: Date;
}
export class DocumentoGenericoDTO implements IDocumentoGenericoDTO {
  constructor(
    public estado?: string,
    public firmas?: IFirmas[],
    public solicitudId?: string,
    public solucionId?: string,
    public tipoDocumento?: string,
    public url?: string,
    public contenidoBase64?: string,
    public createdDate?: Date,
    public lastModifiedDate?: Date
  ) {}
}

export interface IFirmas {
  cvu?: string;
  fechaFirma?: string;
  qrData?: string;
}
